module.exports = __webpack_public_path__ + "static/assets/376daa5444cadd88038ef6ff16bfd653.gif";